export const homepageSlider = function() {
    const homepageContainer = document.querySelector('.jsHomepageSliderContainer');
    if (!homepageContainer) return;
    homepageSlider();

    function homepageSlider() {
        const allSlides = homepageContainer.querySelectorAll('.swiper-slide'),
              arrows = homepageContainer.querySelectorAll('.swiper-button-white');
              
        if (allSlides.length === 1) {
            [].slice.call(arrows).forEach(arrow => {
                arrow.classList.add('hidden');
            });
            return
        } else {
            const homepageSwiper = new Swiper(homepageContainer, {
                loop: true,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                 },
                 speed: 500,
                 navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            });
        }
    }
}
